import { defineStore, storeToRefs } from 'pinia';
import { ref } from 'vue';
import { Route } from 'vue-router';
import { autoUpdateSessionStorage } from '@/apps/order/helper';

import { useRouterStore } from '@/apps/order/stores';

const useOrdersCreateProgressStore = defineStore('ordersCreateProgress', () => {
  const routerStore = useRouterStore();
  const { meta } = storeToRefs(routerStore);

  const fromRoute = ref<Route | undefined>();
  const accessibleSteps = ref<Record<string, boolean>>({
    type: true,
    customer: false,
    category: false,
    calculator: false,
    address: false,
    consumptionPoint: false,
    payment: false,
    customFields: false,
    overview: false,
  });
  autoUpdateSessionStorage(`${meta.value.ctx}.accessibleSteps`, () => accessibleSteps.value);

  const setStepAccessible = (key: string, accessible = true): void => {
    accessibleSteps.value[key] = accessible;
  };

  const reset = (): void => {
    Object.keys(accessibleSteps.value).forEach((step) => {
      accessibleSteps.value[step] = false;
    });

    accessibleSteps.value.type = true;
  };

  return {
    setStepAccessible,
    reset,
    accessibleSteps,
    fromRoute,
  };
});

export default useOrdersCreateProgressStore;
